import repository from 'client/repository';
import alertActions from 'areas/alert/actions';
import themeActions from 'areas/theme/actions';
import { appInsightsService } from 'utilities/logging/appInsightsService';
import configConstants from '../constants';
import { updatePollFrequency } from 'workers/mediator';
import logService from 'utilities/logging/logService';
import env from 'environment';

const appConfigSuccess = (config) => { return { ...config, type: configConstants.APP_CONFIG_SUCCESS }; };

const loadStarted = () => { return { type: configConstants.CONFIG_LOAD_STARTED }; };

const loadEnded = () => { return { type: configConstants.CONFIG_LOAD_ENDED }; };

export default {

    denyReasonsLoaded: (response) => {
        return { ...response, type: configConstants.DENY_REASONS_SUCCESS };
    },

    fuelTypesLoaded: (response) => {
        return { ...response, type: configConstants.FUEL_TYPES_SUCCESS };
    },

    travelMethodsLoaded: (response) => {
        return { ...response, type: configConstants.TRAVEL_METHODS_SUCCESS };
    },

    getAppConfig: () => {
        return async dispatch => {
            try {

                dispatch(loadStarted());

                // query the server for the configuration
                const config = await repository.config.getServerConfig();

                // dispatch this state change
                dispatch(appConfigSuccess(config));

                env.locale = config.locale;
                env.shortDateFormat = config.shortDateFormat;
                env.shortDatePlaceholder = config.shortDatePlaceholder;

                dispatch(themeActions.getTheme(config.theme));
                appInsightsService.init(config.applicationInsightsConnectionString);

                updatePollFrequency(config.clientCacheDurationMinutes);

                dispatch(loadEnded());
            } catch (e) {
                logService.error(e);
                dispatch(alertActions.error(e.toString()));
                dispatch(loadEnded());
            }
        };
    }
};
